export const TYPES = {
  Customer: 'Customer',
  Contact: 'Contact',
  Project: 'Project',
  ProjectContract: 'Project Contract',
  Vendor: 'Vendor',
  Costcodes: 'Costcodes',
  User: 'User',
  SubContract: 'Sub-Contract',
  Buckets: 'Buckets',
  PayableSubContracts: 'PayableSubContracts',
};

export const TYPES_WITH_ARRAY_DATA = new Set([TYPES.Buckets]);

export const isAddressAttribute = (type) => type === 'address';
